import React from "react";

const Check_svg = () => {
  return (
    <div style={{margin:"0 auto"}}>
      <svg
        width="28"
        height="22"
        viewBox="0 0 28 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.8128 2.51715L8.95009 21.3798L0.304688 12.7344L2.52105 10.5181L8.95009 16.9314L25.5964 0.300781L27.8128 2.51715Z"
          fill="#E3530F"
        />
      </svg>
    </div>
  );
};

export default Check_svg;
